import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { AlertDialogComponent } from 'src/app/shared/components/alert-dialog/alert-dialog.component';
import { EntitiesServiceService } from '../../../../../services/entities-service.service';

@Component({
  selector: 'app-cph',
  templateUrl: './cph.component.html',
  styleUrls: ['./cph.component.css']
})
export class CphComponent implements OnInit, OnDestroy {
  @Input() entityId: any;
  @Input() widgetData: any;
  @Input() siteId: any;
  
  isloader: boolean = true;
  isError: boolean = false;
  masterCphData: any = {};
  rul = new FormControl();
  isEditable: boolean = false;
  clutchPadRul: any = [];

  private _intervalTimer: any;
  private _afterClosedSubscription: Subscription;
  private _createRulSubscription: Subscription;
  private _fetchRulSubscription: Subscription;

  constructor(public service: EntitiesServiceService, public sharedService: ServicecallService, private _dialog: MatDialog) { }

  ngOnInit(): void {
    this._fetchRul();
  }
  ngOnDestroy(): void {
    this._afterClosedSubscription?.unsubscribe();
    this._createRulSubscription?.unsubscribe();  
    this._fetchRulSubscription?.unsubscribe();  
    this.clearTimer();
    
  }
  refreshApi() {
    if (+this.widgetData?.refreshRate) {
      this.clearTimer();
      this._intervalTimer = setInterval(() => {
        this._fetchRul();
      }, +this.widgetData?.refreshRate);
      this.isError = false;
    }
  }

  clearTimer() {
    if (this._intervalTimer) {
      clearInterval(this._intervalTimer);
    }
  }

  submitRul(type: string) {
    let dialogRef = this._dialog.open(AlertDialogComponent, {
      data: { msg: type === 'reset' ? 'Are you sure you want to reset?' : 'Are you sure you want save changes?' },
      disableClose: true
    });
    this._afterClosedSubscription = dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const payload = {
          type: type,
          entityId: this.entityId,
          class: 'RUL_CLUTCH_PAD',
          rulValue: type === 'reset' ? this.sharedService.resetRULDetials('RUL_CLUTCH_PAD')?.lifetime : this.rul.value,
          // odometerValue: 45000
        }
        this._createRulSubscription = this.service.createRul(payload).subscribe((result: any) => {
          this.sharedService.toasterService({ type: 'success', msg: result['message'] });
          this.masterCphData = result?.data;
          this.rul.reset();
          this.rul.setValue(this.masterCphData?.rulValue);
          this._setGaugeData();
          this.refreshApi();
        });
      }
    });
  }

  infoHoverLabel(operation: string) {
    const details = '\nDesign Life : ' + (this.sharedService.resetRULDetials('RUL_CLUTCH_PAD')?.lifetime).toString() + '\nRUL Predicted : ' +
      (this.masterCphData?.rulValue ? this.masterCphData?.rulValue?.toString() : '0') + '\nRUL Predicted % : ' +
      ((this.masterCphData?.rulPercentage || this.masterCphData?.rulPercentage === 0) ? ((this.masterCphData?.rulPercentage % 1) !== 0 ? this.masterCphData?.rulPercentage?.toFixed(5) : this.masterCphData?.rulPercentage) : '') +
      '\nReplacement Threshold : ' + this._getCpThreshold('Replace', 'upperThreshold')?.toString();
    switch (operation) {
      case 'manual': return 'Initailized by user' + details;
      case 'computed': return 'Remaining useful life computed by algorithm - ' + this.masterCphData?.type + details;
      default: return '';
    }
  }


  private _fetchRul() {
    const payload = {
      class: 'RUL_CLUTCH_PAD',
      entityId: this.entityId
    }
    this._fetchRulSubscription = this.service.fetchRul(payload).subscribe(
      {
        next: (result: any) => {
          this.masterCphData = result;
          this.rul.setValue(this.masterCphData?.rulValue);
          this.isloader = false;
          this._setGaugeData();
        },
        error: (error) => {
          if (error) {
            this.isloader = false;
            this.isError = true;
            this.masterCphData.rulValue = 0;
            this.rul.setValue(this.masterCphData?.rulValue);
            this._setGaugeData();
          }
        }
      }
    )
  }

  private _setGaugeData() {
    this.clutchPadRul = [[
      {
        type: "indicator",
        mode: "gauge+number",
        value: this.masterCphData?.rulValue ? this.masterCphData?.rulValue : 0,
        gauge: {
          axis: { range: [null, this.sharedService.resetRULDetials('RUL_CLUTCH_PAD')?.lifetime], showticklabels: false, ticks: "" },
          bar: { color: "#055C7B", thickness: .3 },
          steps: [
            { range: [this._getCpThreshold('Replace', 'lowerThreshold'), this._getCpThreshold('Replace', 'upperThreshold')], color: "#F65E4C", thickness: .5 },
            { range: [this._getCpThreshold('Replace', 'lowerThreshold'), this._getCpThreshold('Excellent', 'upperThreshold')], color: "#F2F4F3", thickness: .3 }
          ],
          bordercolor: "transparent",
        },
        height: 150,
        annotation: [
          {
            text: this.sharedService.resetRULDetials('RUL_CLUTCH_PAD')?.unit + " Left",
            showarrow: false,
            y: .6,
            font: {
              family: "Inter",
              size: 18,
              color: "#615E83"
            },
          }
        ]
      }
    ]];
    this.refreshApi();
  }

  private _getCpThreshold(thresholdLabel: string, searchKey: string) {
    return this.sharedService.resetRULDetials('RUL_CLUTCH_PAD')?.status?.find((item: any) => item?.label === thresholdLabel)?.[searchKey];
  }

  private _cancelEntry() {
    this.rul.reset();
    this.rul.setValue(this.masterCphData?.rulValue);
  }
 
}

